import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/Login/LoginPage';

// Importar das novas pastas
import ProfilePage from './pages/Profile/ProfilePage';
import ProfileFormPage from './pages/Profile/ProfileFormPage';
import PersonListPage from './pages/Person/PersonListPage';
import PersonFormPage from './pages/Person/PersonFormPage';
import PersonFeedPage from './pages/PersonFeed/PersonFeedPage'; // Importar a nova página
import PersonFeedFormPage from './pages/PersonFeed/PersonFeedFormPage'; // Importar a nova página de formulário

// Importar páginas de Empresa (Adicionar)
import CompanyListPage from './pages/Company/CompanyListPage';
import CompanyFormPage from './pages/Company/CompanyFormPage';

// Importar páginas de Equipamento (Adicionar)
import EquipmentListPage from './pages/Equipment/EquipmentListPage';
import EquipmentFormPage from './pages/Equipment/EquipmentFormPage';

// Importar página de Parâmetros (Adicionar)
import ParametersPage from './pages/Parameters/ParametersPage';

// Importar páginas de Contrato (Adicionar)
import ContractListPage from './pages/Contract/ContractListPage';
import ContractFormPage from './pages/Contract/ContractFormPage';

// Importar DashboardPage
import DashboardPage from './pages/Dashboard/DashboardPage';

// NotFound pode ficar na raiz de pages ou ir para Common/Shared
import NotFoundPage from './pages/NotFoundPage';

// Definir o tema customizado
const theme = createTheme({
  palette: {
    primary: {
      main: '#001E8F',
    },
  },
  typography: {
    htmlFontSize: 12,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        margin: 'dense'
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: 'small',
        margin: 'dense'
      }
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiSwitch: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiIconButton: {
        defaultProps: {
            size: 'small'
        }
    },
    MuiChip: {
      defaultProps: {
        size: 'small'
      }
    }
  },
});

// Componente para envolver o Layout com Outlet
const LayoutWithOutlet = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate initial loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Rotas protegidas */}
        <Route element={<ProtectedRoute />}>
          <Route element={<LayoutWithOutlet />}>
            <Route path="/dashboards" element={<DashboardPage />} />
            <Route path="/" element={<Navigate to="/dashboards" replace />} />
            <Route path="/profiles" element={<ProfilePage />} />
            <Route path="/profiles/new" element={<ProfileFormPage />} />
            <Route path="/profiles/edit/:id" element={<ProfileFormPage />} />
            <Route path="/pessoas" element={<PersonListPage />} />
            <Route path="/pessoas/new" element={<PersonFormPage />} />
            <Route path="/pessoas/edit/:id" element={<PersonFormPage />} />
            <Route path="/empresas" element={<CompanyListPage />} />
            <Route path="/empresas/new" element={<CompanyFormPage />} />
            <Route path="/empresas/edit/:id" element={<CompanyFormPage />} />
            <Route path="/equipment" element={<EquipmentListPage />} />
            <Route path="/equipment/new" element={<EquipmentFormPage />} />
            <Route path="/equipment/edit/:id" element={<EquipmentFormPage />} />
            <Route path="/parametros" element={<ParametersPage />} />
            <Route path="/contracts" element={<ContractListPage />} />
            <Route path="/contracts/new" element={<ContractFormPage />} />
            <Route path="/contracts/edit/:id" element={<ContractFormPage />} />
            <Route path="/contracts/view/:id" element={<ContractFormPage />} />
            
            {/* Rotas do Feed de Pessoas */}
            <Route path="/person-feed" element={<PersonFeedPage />} />
            <Route path="/person-feed/new" element={<PersonFeedFormPage />} />
            <Route path="/person-feed/view/:id" element={<PersonFeedFormPage />} />
            
          </Route>
        </Route>
        
        {/* Página 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;